/**
 * @fileoverview Agent definition for scene-prompt-creator-v1.
 *
 * This agent generates a full image-gen prompt from prose and a locked
 * composition directive chosen by the user via the scene explorer.
 * It does not make independent creative decisions about shot framing.
 *
 * @category visuals.prompts.story
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'scene-prompt-creator-v1',
  kind: 'primitive',
  name: 'Scene Prompt Creator',
  description: 'Generates a full image-gen prompt from prose and a locked composition directive.',
  category: 'visuals',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-04',
    lastUpdated: '2026-04',
    taxonomyPath: 'visuals.prompts.story',
    usedBy: [
      'use-explore-scenes.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'scene-explorer-v1',
      'story-image-prompt-creator-v2',
    ],
  },
};
